<template>
  <fragment>
    <mc-app-header title="Overall Analytics" />
    <mc-app-body>
      <div class="section">
        <b-loading v-if="loading" active :is-full-page="false" />
        <mc-error-layout
          v-else-if="error"
          message="Failed to load data!"
          :retry-fn="() => loadData()"
        />
        <b-table v-else :data="overallAnalyticsData" :columns="columns" />
      </div>
    </mc-app-body>
  </fragment>
</template>

<script>
import { mapActions } from 'vuex';
import { DateTime } from 'luxon';

const dayLables = ['Today', 'Yesterday'];

export default {
  data() {
    return {
      loading: true,
      error: false,
      overallAnalyticsData: null,
      columns: [
        {
          field: 'day',
          label: 'Day'
        },
        {
          field: 'attemptsCreated',
          label: 'Created Concept Attempts',
          numeric: true,
          centered: true
        },
        {
          field: 'attemptsCompleted',
          label: 'Completed Concept Attempts',
          numeric: true,
          centered: true
        },
        {
          field: 'challengesUnlocked',
          label: 'Unlocked Challenges',
          numeric: true,
          centered: true
        }
      ]
    };
  },
  methods: {
    ...mapActions('functions', ['callFunction']),
    async loadData() {
      this.loading = true;
      this.error = false;
      try {
        const now = DateTime.fromJSDate(new Date());
        const dataForLastThreeDays = await Promise.all(
          [2, 1, 0].map(async diff => {
            const date = now.minus({ days: diff });
            return {
              day: `${dayLables[diff] ||
                date.toFormat('EEEE')} (${date.toFormat('MMM d')})`,
              ...(await this.getData(date.toString()))
            };
          })
        );
        this.loading = false;
        this.overallAnalyticsData = dataForLastThreeDays;
      } catch (e) {
        this.loading = false;
        this.error = true;
        this.$buefy.toast.open({
          message: e.message || 'Error Calling Function!',
          type: 'is-danger'
        });
      }
    },
    async getData(date) {
      return await this.callFunction({
        name: 'adminOverallAnalyticsGet',
        params: {
          date
        }
      });
    }
  },
  created() {
    this.loadData();
  }
};
</script>

<style></style>
